<template>
    <div class="input-error" :class="positionClass">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        staticPosition: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        positionClass() {
            return {
                'input-error--static': this.staticPosition,
            };
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.input-error {
    position: absolute;

    &--static {
        position: static;
    }
}
</style>
